import { useMemo } from 'react';
import { useQuery } from 'react-query';
import FloorPlanService from '../../services/floorPlanService';
import { getDistinctBedroomCounts } from './utils';

const floorPlanService = new FloorPlanService();

const useFetchBedroomSizes = ({ organizationId, propertyId }) => {
  const { data, isLoading } = useQuery(
    ['floorPlans', organizationId, propertyId],
    () => floorPlanService.getAll(organizationId, propertyId, {}),
    {
      enabled: Boolean(organizationId && propertyId),
      select: (data) => data || [],
    },
  );

  // Derived from the query result, so it changes only when the query does.
  // Recomputing inline would hand consumers a new array on every render and
  // defeat the useMemo the tab strip keys on it.
  const bedroomCounts = useMemo(() => getDistinctBedroomCounts(data), [data]);

  // Same cached query, no extra request: the reinstate wizard prefills its
  // floor-plan control from the full list, not just the bedroom counts.
  const floorPlans = useMemo(() => data ?? [], [data]);

  return {
    bedroomCounts,
    floorPlans,
    isLoadingBedroomSizes: isLoading,
  };
};

export default useFetchBedroomSizes;
